import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BinaService } from '../../../services/bina/bina.service';


import { MatSnackBar } from '@angular/material';
import { ToastComponent } from '../../toast/toast.component';

export interface DialogData {
    id: any;
}

@Component({
    selector: 'app-confirm-binas',
    templateUrl: './confirm-binas.component.html',
    styleUrls: ['./confirm-binas.component.scss']
})
export class ConfirmBinasComponent implements OnInit {

    public code = '';
    public loading = false;

    constructor(
        public dialogRef: MatDialogRef<ConfirmBinasComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        public binaService: BinaService,
        private snackBar: MatSnackBar
    ) { }

    ngOnInit() {
    }


    onNoClick(): void {
        this.dialogRef.close();
    }



    confirm() {
        this.loading = true;
        this.binaService.confirm(this.data.id, this.code).subscribe((res) => {
            this.loading = false;
            if (res.success) {
                this.snackBar.openFromComponent(ToastComponent, {
                    data: res.msg
                });
                this.dialogRef.close(res.id);
            } else {
                this.snackBar.openFromComponent(ToastComponent, {
                    data: res.msg
                });
            }
        })  
    }

    resend(id){
        this.loading = true;
        this.binaService.resend(id).subscribe((res)=>{
            this.loading = false;
            
            this.snackBar.openFromComponent(ToastComponent, {
                data: res.msg
            });
            
        })
    }

}
